<template>
  <!-- toast -->
  <AlertMsg :msg="msgObj.msg" :show="msgObj.show" :role="msgObj.role" @closePopup="reset"></AlertMsg>
  <!-- end toast -->
  <div class="row">
    <div class="col-12">
      <div class="d-flex align-items-center">
        <h5 class="mb-0 text-primary"><i class="fas fa-donate text-primary"></i> Fees Group</h5>
      </div>
      <hr />
      <div class="row g-3">
             <div class="col-md-3">
            <label class="form-label">
              Class<sup><span class="text-danger font-12">*</span></sup> :
            </label>
            <div class="dropdown">
              <button class="form-select form-select-sm rounded dropdown-toggle w-100 dropdown-a"  type="button" data-bs-toggle="dropdown" aria-expanded="false">
                {{ clsList.find(c => c._id === Obj.ClassName)?.name || "" }}
              </button>
              <ul class="dropdown-menu w-100 scrollable-menu" >
                <li v-for="(item, index) in uniqueClsList" :key="index">
                  <a class="dropdown-item" href="#" @click.prevent="Obj.ClassName = item._id"  >
                    {{ item.name }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
       
        <div class="col-md-3">
          <label class="form-label">
            Fee Type<sup><span class="text-danger font-12">*</span></sup> :
          </label>
          <multiselect v-model="Obj.FeeType" :options="feeOptions" :multiple="true" :close-on-select="false"
            :clear-on-select="false" :preserve-search="true" placeholder="Select Fee Types" label="Name" track-by="Name"
            class="form-select form-select-sm p-0 z-0 cursor-pointer" role="button" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Total:</label>
          <input type="text" class="form-control form-control-sm" v-model="Obj.Total" readonly />
        </div>
        <div class="col-md-9 text-end">
          <button class="btn btn-sm btn-darknavy me-1" @click="save()">
            <i class="fa fa-save"></i> Save
          </button>
           <button type="button" class="btn btn-sm btn-soft-dark" @click="reset()"><i class="fa fa-times-circle  me-1"></i> Cancel</button>
        </div>
      </div>
      <ul v-if="errors.length" class="text-danger ps-3">
          <li v-for="(err, index) in errors" :key="index">{{ err }}</li>
        </ul>
      <div class="row mt-3">
        <div class="col-md-9 table-responsive">
          <div class="progress mb-0 progress-sm" v-if="progress!=0">
        <div class="progress-bar" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"
          :style="{ width: progress + '%' }"></div>
      </div>
          <DataTable  v-if="progress==0" :columns="cols" :rows="rows" :pageSize="10"   :actions="{  edit: handleEdit, delete: handleDelete }" />
        </div>
      </div>
    </div>
  </div>
  <DelPopup :name="delObj.Total" @delRecord="delRecord" @closeModal="delObj.Total = ''"></DelPopup>
</template>
<script setup>
import AlertMsg from "@/components/Common/AlertMsg.vue";
import DelPopup from "@/components/Common/DelPopup.vue";
import DataTable from "@/components/Common/DataTable.vue";
import { isRequired, validateForm } from "@/utils/validation.js";
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import { curdStatus, api } from '@/utils/helpers.js';
import { ref, onMounted} from 'vue'
import { watch } from 'vue';
import { schoolStore } from '@/utils/schoolStore';
const { clsList,uniqueClsList} = schoolStore();
  const  Obj = ref( {ClassName: "", FeeType: [], Total: 0, })
  const feeOptions= ref([])
    const   msgObj= ref({ msg: "", role: "", show: false, })
    const   delObj = ref({})
    const   errors= ref({})
const cols=ref([
  { label: 'S.No', key: 'Sno' },
  { label: 'Class', key: 'Class' },
  { label: 'Fee Type', key: 'FeeType',truncatable: true },
  { label: 'Total', key: 'Total' },
]);
const handleEdit = (row) => {
  const selectedFeeTypes = row.FeeType.split(',').map(name =>
    feeOptions.value.find(f => f.Name === name.trim())
  ).filter(Boolean); 
  Obj.value = {
    ClassName: clsList.value.find(cls => cls.name === row.Class)?._id || "",
    FeeType: selectedFeeTypes,
    Total: row.Total,
    _id: row._id, 
  };
};
const handleDelete = (row) => {
  delObj.value = { ...row };
}
const rows=ref([])
watch(
  () => Obj.value.FeeType,
  (newAmount) => {
    if (Array.isArray(newAmount)) {
      Obj.value.Total = newAmount.reduce((sum, fee) => sum + Number(fee.Amount || 0), 0);
    } else {
      Obj.value.Total = 0;
    }
  },
  { deep: true, immediate: true }
);
 const loadFeeOptions = async() => {
      try {
        const response = await api.get('/Fees/all');
        feeOptions.value = response.data.map(fee => ({
          Name: fee.Name,
          Amount: Number(fee.Amount),
        }));
      } 
      catch (error) { console.error("Failed to load fees:", error); }
    }
    const save= async()=> {
      const fields = {
        Class: { value: Obj.value.ClassName, validators: [isRequired], },
        FeeType: { value: Obj.value.FeeType, validators: [isRequired], },
        Total: { value: Obj.value.Total, validators: [isRequired], },
      };
      errors.value = validateForm(fields);
      if (Object.keys(errors.value).length === 0) {
         const duplicate = rows.value.find(
      (row) => row.ClassName === Obj.value.ClassName && row._id !== Obj.value._id
    );
    if (duplicate) {
      msgObj.value = { msg: "Fee Group already Exists Update it", role: "danger", show: true };
      return;
    }
        const { url, method, msg } = curdStatus(Obj.value);
        await api[method](`/feesgroup${url}`, Obj.value)
          .then(() => {
            loadData();
            reset();
            msgObj.value = { msg: `Fee Group ${msg} Successfuly`, role: "success", show: true, }; 
          })
          .catch((error) => { console.log(error); });
      }
    }
    const reset= async() => {
      Obj.value = { ClassName: "", FeeType: [], Total: 0, };
      msgObj.value = { msg: "", role: "", show: false, };
      errors.value={};
    }
     const progress = ref(0)
 const loadData = async () => {
  let direction = 1;
  let progressInterval = setInterval(() => {
    progress.value += direction;
    if (progress.value >= 100) {
      progress.value = 0;
    }
  }, 100);

  await api.get('/feesgroup/all')
    .then((response) => {
      rows.value = response.data .map((item) => ({ ...item,
          Class: clsList.value.find(cls => cls._id === item.ClassName)?.name || '',
          FeeType: Array.isArray(item.FeeType)
            ? item.FeeType.flat(Infinity).map(f => f?.Name || f?.name || '').filter(Boolean).join(', ')
            : '',
          Total: Number(item.Total), })) .slice() .sort((a, b) => a.Class.localeCompare(b.Class))
        .map((item, i) => ({ ...item, Sno: i + 1, }));
      progress.value = 0;
      clearInterval(progressInterval);
    });
};

    const delRecord= async()=> {
      await api.delete(`/feesgroup/${delObj.value._id}`)
        .then(() => {
          loadData();
          delObj.value={};
          msgObj.value = { msg: "Fee Group Deleted Successfuly.", role: "danger", show: true, };
        });
    }
 onMounted(() => { loadData(); loadFeeOptions(); })
</script>
<style>
.multiselect {
  z-index: 9999;
}
.multiselect__tags {
  max-height: 38px;
  overflow-y: auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.multiselect__tags::-webkit-scrollbar {
  width: 4px;
}
.multiselect__tags::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius: 2px;
}
</style>